<div class="centered">
  <h1>Outdated Browser Detected</h1>
  <br />
  We've detected that you are using an outdated browser! For a better user
  experience, we recommend that you use the latest version of Microsoft Edge,
  Google Chrome or Firefox.
</div>
